import ArticlesRepository from "../../repositories/articlesRepo";

export default {
  namespaced: true,
  state: {
    articles: []
  },
  mutations: {
    // Set articles
    SET_ARTICLES(state, articles) {
      state.articles = articles;
    },

    // Clean articles object
    cleanProject(state) {
      state.articles = [];
    }
  },
  actions: {
    // Get all articles from api
    async fetchArticles({ commit }) {
      try {
        const { data } = await ArticlesRepository.fetchArticles();

        commit("SET_ARTICLES", data);
      } catch (error) {
        // TODO: NOTIFICIATIONS
        console.error(error);

        throw error;
      }
    },

    async createArticle(context, { project_uuid, payload }) {
      try {
        const { data } = await ArticlesRepository.add(project_uuid, payload);

        return data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    // Clean store
    cleanArticles({ commit }) {
      commit("setProjects", []);
    }
  }
};
